import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from "@mui/material";
import { theme } from "./theme";
import AppRoutes from '../src/routes/AppRoutes';
import { useEffect } from "react";
import { initPolishOrphansFixer } from "./utils/fixPolishOrphans.jsx";
import ScrollToTop from './utils/ScrollToTop.jsx';
import CookieBanner from "./components/CookieBanner/CookieBanner";
import { loadAllowedTrackers } from "./components/CookieBanner/trackerLoader";

function App() {
  useEffect(() => {
    initPolishOrphansFixer();
    loadAllowedTrackers();
  }, []);
  return (

    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <ScrollToTop />
        <AppRoutes />
        <CookieBanner />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
